import React from 'react';
import {Sparkles, Languages} from 'lucide-react';
import {useHref, useLocation} from 'react-router';
import HeaderLogoLocaleLink from './HeaderLogoLocaleLink';

import {docsBasePath as basePath} from '../../site-config.mjs';

export default function LanguageSwitcher(): React.ReactNode {
  const location = useLocation();
  const path = location.pathname === basePath
    ? '/'
    : location.pathname.startsWith(`${basePath}/`) ? location.pathname.slice(basePath.length) : location.pathname;
  const isChinese = path === '/zh-CN' || path.startsWith('/zh-CN/');
  const nextPath = isChinese
    ? path.replace(/^\/zh-CN(?=\/|$)/, '') || '/'
    : `/zh-CN${path === '/' ? '/' : path}`;

  // A real link remains usable before hydration and fully initializes the
  // target locale's navigation. Localized heading IDs must not be carried over.
  const target = nextPath.replace(/\/+$/, '') || '/';
  const homeTarget = target === '/' ? '/home' : target === '/zh-CN' ? '/zh-CN/home' : target;
  const href = useHref(`${homeTarget}${location.search}`);

  return (
    <>
      <HeaderLogoLocaleLink />
      <AiDocsLink isChinese={isChinese} />
      <a className="language-switcher" href={href} title={isChinese ? 'Switch to English' : '切换到简体中文'}>
        <Languages size={16} />
        <span>{isChinese ? 'English' : '简体中文'}</span>
      </a>
    </>
  );
}

function AiDocsLink({isChinese}: {isChinese: boolean}) {
  return <button type="button" className="language-switcher" onClick={() => window.dispatchEvent(new Event('weex:open-ai'))} title={isChinese ? '向 AI 询问本页内容' : 'Ask AI about this page'}><Sparkles size={16}/><span>{isChinese ? 'AI 问答' : 'Ask AI'}</span></button>;
}
